import * as React from 'react'
import { Remove as ExpandLessIcon, Add as ExpandMoreIcon } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, Collapse, IconButton, Table, TableBody, TableRow, TableCell } from '@mui/material'
import { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/system'
import { formatNumber } from 'utils/formatters'

const DataRow = styled(TableRow)(({ theme }) => ({
  '&:last-of-type td, &:last-of-type th': {
    border: 0,
  },
}))

const DataCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    ...theme.typography.body1,
    paddingLeft: 0,
    paddingRight: 0,
  },
  [`&.quantity`]: {
    width: '90px',
    textAlign: 'right',
    fontWeight: 600,
  },
}))

/**
 * IngredientItem component
 */
const IngredientItem = ({ item }) => {
  return (
    <DataRow>
      <DataCell>{item.name}</DataCell>
      <DataCell className="quantity">
        <Box component="span" color="success.main">{formatNumber(item.cookedQty)}g</Box>
      </DataCell>
      <DataCell className="quantity">
        {item.rawQty && 
          <Box component="span" color="info.main">{`${formatNumber(item.rawQty, { decimals: 1, showDecimalOnZero: false })}${item.rawUnit}`}</Box>
        }
      </DataCell>
    </DataRow>
  )
}

/**
 * IngredientGroup component
 */
const IngredientGroup = ({ group }) => {
  const [expanded, setExpanded] = React.useState(false)

  return (
    <Card variant="outlined" sx={{ my: 3 }}>
      <CardHeader
        onClick={() => setExpanded(!expanded)}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          bgcolor: 'grey.200',
        }}
        avatar={
          <IconButton size="small" edge="start" disableRipple={true} sx={{ padding: 0, color: 'text.primary' }}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        title={group.name}
        slotProps={{
          title: { color: 'text.primary', style: { fontSize: '1rem' } },
        }}
      />
      <Collapse in={expanded}>
        <CardContent>
          <Table size="small">
            <TableBody>
              {group.ingredients.map((item) => (
                <IngredientItem key={item.name} item={item} />
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Collapse>
    </Card>
  )
}

export default IngredientGroup
